import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { keyBy, uniqBy } from 'lodash';

import './index.scss';
import CommonTable from '../../common/table';
import {
  REDUCER_NAME,
  fetchAutoNews,
  resetStoreData,
  fetchAutoNewsInterval,
} from '../../reducer';
import Const from '../../Const';
import { getDataFollowKeyByDot } from '../../../helpers/Common';

const INTERVAL_TIME = 30000;

class AutoNews extends React.Component {
  componentDidMount() {
    const { fetchAutoNews, resetStoreData, fetchAutoNewsInterval } = this.props;
    resetStoreData('autoNewsData');
    fetchAutoNews();
    this.intervalId = setInterval(() => {
      fetchAutoNewsInterval();
    }, INTERVAL_TIME);
  }

  componentDidUpdate(prevProps) {
    const { fetchAutoNews, resetStoreData } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      resetStoreData('autoNewsData');
      fetchAutoNews();
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  transformData = data => {
    return data;
  };

  render() {
    const {
      autoNewsData: {
        data,
        isLoading,
        filterCondition,
        isShortByFavorite,
        storeName,
      },
      autoNewsData,
    } = this.props;

    const filteredData = this.transformData(data, filterCondition);
    //data with condition
    const listIdsInLocalStore =
      JSON.parse(localStorage.getItem(storeName)) || [];
    //data in Local Store
    const uniqueIds = uniqBy(listIdsInLocalStore, e => {
      return e;
    });
    // make list unique

    const listFullData = keyBy(filteredData, Const.NewsAggregatorTable.ID);
    const listIds = filteredData.map(item =>
      getDataFollowKeyByDot(item, Const.NewsAggregatorTable.ID),
    );
    const idsInCurrentList = uniqueIds.filter(id => listIds.includes(id));

    const optProps = isShortByFavorite
      ? {
          isGroupData: false,
          ids: idsInCurrentList,
        }
      : {
          ids: listIds,
        };

    return (
      <CommonTable
        listColumn={Const.AutoNewsTable}
        list={listFullData}
        isLoading={isLoading}
        isShortByFavorite={isShortByFavorite}
        type="an"
        dateKey="createDate"
        commonData={autoNewsData}
        {...optProps}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    autoNewsData: state[REDUCER_NAME].autoNewsData,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  fetchAutoNews,
  fetchAutoNewsInterval,
  resetStoreData,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(AutoNews);
